import { graphql } from '@search/gql-client/src';

export const AgentSavingSearchMutation = graphql`
  mutation AgentSavingSearchMutation(
        $customerId: ID!,
        $email: String,
        $title: String!,
        $filters: ProfessionalSearchInput!
    ) {
    businessSavingSearch(email: $email, customerId: $customerId, title: $title, filters: $filters) {
      email
      isSuccess
    }
  }
`;
